import { ConnectionStatusFilterEnum } from '@vangst/services/oogst/types'
import useViewer from '@vangst/services/oogst/viewer/useViewer'
import { useMemo } from 'react'
import { MdChecklist, MdPerson, MdPersonAdd } from 'react-icons/md'
import GroupHeader from '../../components/views/GroupHeader'
import MemberConnectionsGrid from './MemberConnectionsGrid'
import MemberJobApplicationsGrid from './MemberJobApplicationsGrid'

export default function MemberDashboardSections() {
  const { viewer } = useViewer()
  const vars = useMemo(
    () => ({
      memberApplications: { username: viewer?.username ?? '' },
      memberConnections: { username: viewer?.username ?? '', first: 24 },
      memberConnectionsPending: {
        username: viewer?.username ?? '',
        status: ConnectionStatusFilterEnum.PendingReceived,
        first: 9,
      },
    }),
    [viewer],
  )
  return (
    <>
      {viewer?.permissions?.applyToJobs && (
        <section className="flow-y-sm">
          <GroupHeader
            icon={MdChecklist}
            title="My Applications"
            to={viewer?.routes?.jobApplications}
            toLabel="View My Applications"
          ></GroupHeader>
          <MemberJobApplicationsGrid
            as="card"
            at="preview"
            classNameList="grid-three-up"
            take={6}
            variables={vars.memberApplications}
          />
        </section>
      )}
      <section className="flow-y-sm">
        <GroupHeader
          icon={MdPersonAdd}
          title="Pending Connections"
          to={viewer?.routes?.connections}
          toLabel="View All Connections"
        ></GroupHeader>
        <div className="grid">
          <MemberConnectionsGrid
            as="card"
            at="preview"
            classNameList="grid-three-up"
            take={9}
            variables={vars.memberConnectionsPending}
          />
        </div>
      </section>
      <section className="flow-y-sm">
        <GroupHeader
          icon={MdPerson}
          title="Connections"
          to={viewer?.routes?.connections}
          toLabel="View All Connections"
        ></GroupHeader>
        <div className="grid">
          <MemberConnectionsGrid
            as="card"
            at="preview"
            classNameList="grid-three-up"
            take={9}
            variables={vars.memberConnections}
          />
        </div>
      </section>
    </>
  )
}
